import { db } from "../firebase";
import { doc, getDoc, getDocs, setDoc, collection, query, where } from "firebase/firestore";
import { langNgheFirestore } from "../lib/langNgheFirestore";

const giaTheoNgayCol = () => collection(db, "giaTheoNgay");

// 1 tài liệu cho mỗi (loại bơ, ngày) — dùng luôn "maLoaiBo_ngay" làm ID để
// admin sửa giá trong ngày là ghi đè tự nhiên (setDoc), không tạo trùng.
const idTaiLieu = (maLoaiBo, ngay) => `${maLoaiBo}_${ngay}`;

export const giaTheoNgayApi = {
  // ngay dạng "YYYY-MM-DD".
  async layGia(maLoaiBo, ngay) {
    if (!maLoaiBo || !ngay) return null;
    const snap = await getDoc(doc(db, "giaTheoNgay", idTaiLieu(maLoaiBo, ngay)));
    return snap.exists() ? snap.data().donGia : null;
  },

  async layTheoNgay(ngay) {
    const snap = await getDocs(query(giaTheoNgayCol(), where("ngay", "==", ngay)));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  langNgheTheoNgay(ngay, onChange, onError) {
    if (!ngay) {
      onChange([]);
      return () => {};
    }
    return langNgheFirestore(query(giaTheoNgayCol(), where("ngay", "==", ngay)), {
      onChange,
      onError,
    });
  },

  // 1 khoảng ngày bất kỳ, mọi loại bơ — lọc riêng theo loại bơ được làm ở phía
  // component (xem GiaTheoNgay). Range 1 field trên "ngay" (dạng "YYYY-MM-DD"
  // nên so sánh chuỗi = so sánh ngày) không cần composite index.
  async trongKhoang(tuNgay, denNgay) {
    const snap = await getDocs(
      query(giaTheoNgayCol(), where("ngay", ">=", tuNgay), where("ngay", "<=", denNgay))
    );
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  async dat({ maLoaiBo, ngay, donGia, capNhatBoi }) {
    const ref = doc(db, "giaTheoNgay", idTaiLieu(maLoaiBo, ngay));
    const data = {
      maLoaiBo,
      ngay,
      donGia: Number(donGia),
      capNhatLuc: new Date().toISOString(),
      capNhatBoi: capNhatBoi ?? null,
    };
    await setDoc(ref, data);
    return { id: ref.id, ...data };
  },
};
